import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/services/core/auth/auth.service';
import { PopoverController } from '@ionic/angular';
import { MenuService } from 'src/app/core/services/core/menu.service';
import { NavigationHelper } from 'src/app/core/services/core/navigation-helper.service';
import { AlertBuilder } from 'src/app/core/services/helpers/auth-helper.service';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss']
})
export class ProfileMenuComponent implements OnInit {
  constructor(
    private popoverController: PopoverController,
    public menu: MenuService,
    private alertBuilder: AlertBuilder,
    public nav: NavigationHelper,
    public auth: AuthService
  ) {}

  ngOnInit() {}

  onMyProfile() {
    this.closePopover();
    this.nav.root('profile/home');
  }

  onMail() {
    this.closePopover();
    this.nav.root('inbox');
  }

  async onLogout() {
    await this.closePopover();
    this.alertBuilder.logout();
  }

  private closePopover() {
    return this.popoverController.dismiss();
  }
}
